import { LiveIcon } from '../BottomNav/icons/LiveIcon';

/**
 * Shown when every group is empty (spec §5.3) — the header strip above still
 * renders with "0 Live Now". Events join the page as resolution approaches,
 * hence the copy.
 */
export function LiveEmptyState() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 px-4 py-16 text-center">
      <span className="flex items-center justify-center size-16 rounded-full bg-danger/10 text-danger">
        <LiveIcon className="size-8" />
      </span>
      <h2 className="m-0 text-xl font-semibold text-ink">Nothing live right now</h2>
      <p className="m-0 max-w-xs text-sm text-muted">Events appear here as they get close to resolving. Check back soon.</p>
    </div>
  );
}
